class Nft {
  constructor(
    id,
    title,
    imageUrl,
    artist,
    collection,
    blockchain,
    contractAddr,
    tokenId,
    collectionImageUrl,
    imageThumbnailUrl,
    imageOriginalUrl,
    animationUrl
  ) {
    this.id = id;
    this.title = title;
    this.imageUrl = imageUrl;
    this.artist = artist;
    this.collection = collection;
    this.blockchain = blockchain;
    this.contractAddr = contractAddr;
    this.tokenId = tokenId;
    this.collectionImageUrl = collectionImageUrl;
    this.imageOriginalUrl = imageOriginalUrl;
    this.imageThumbnailUrl = imageThumbnailUrl;
    this.animationUrl = animationUrl;
  }
}

export default Nft;
